module.exports = __webpack_public_path__ + "static/media/google_icon.10c25a60.svg";